<template>
  <b-container
    fluid
  >
    <b-row class="mb-4">
      <b-col
        cols="12"
      >
        <b-card
          title="Payment Requests"
          sub-title="My Requests"
          class="shadow-sm"
        >
          <b-row>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
              order="1"
            >
              <PaleCard
                label="Pending"
                variant="warning"
                :count="expenses.pending"
                :link="{ name: 'user.payments.requests', params: { user: 'pending' }}"
                :loading="fetching"
              />
            </b-col>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
              order="2"
            >
              <PaleCard
                label="Canceled"
                variant="danger"
                :count="expenses.canceled"
                :link="{ name: 'user.payments.requests', params: { user: 'histories', status: 'canceled' }}"
                :loading="fetching"
              />
            </b-col>
            <b-col
              cols="6"
              md="2"
              lg="2"
              order="6"
              order-md="3"
            />
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
              order="3"
              order-md="4"
            >
              <PaleCard
                label="Processing"
                variant="warning"
                :count="expenses.processing"
                :link="{ name: 'user.payments.requests', params: { user: 'pending' }}"
                :loading="fetching"
              />
            </b-col>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
              order="4"
              order-md="5"
            >
              <PaleCard
                label="Released"
                variant="success"
                :count="expenses.released"
                :link="{ name: 'user.payments.requests', params: { user: 'histories', status: 'released' }}"
                :loading="fetching"
              />
            </b-col>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
              order="5"
              order-md="6"
            >
              <PaleCard
                label="Disapproved"
                variant="danger"
                :count="expenses.disapproved"
                :link="{ name: 'user.payments.requests', params: { user: 'histories', status: 'disapproved' }}"
                :loading="fetching"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row
      v-if="Number(user?.is_approver || 0) === 1"
    >
      <b-col
        cols="12"
      >
        <b-card
          title="Payment Requests"
          sub-title="My Approvals"
          class="shadow-sm"
        >
          <b-row>

            <b-col
              offset-md="6"
              cols="6"
              md="2"
              lg="2"
              class="p-2"
            >
              <PaleCard
                label="Pending"
                variant="warning"
                :count="approvals.pending"
                :link="{ name: 'user.payments.approvals', params: { approver: 'pending' }}"
                :loading="fetching"
              />
            </b-col>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
            >
              <PaleCard
                label="Approved"
                variant="success"
                :count="approvals.approved"
                :link="{ name: 'user.payments.approvals', params: { approver: 'histories', status: 'approved' }}"
                :loading="fetching"
              />
            </b-col>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="p-2"
            >
              <PaleCard
                label="Disapproved"
                variant="danger"
                :count="approvals.disapproved"
                :link="{ name: 'user.payments.approvals', params: { approver: 'histories', status: 'disapproved' }}"
                :loading="fetching"
              />
            </b-col>

          </b-row>
        </b-card>
      </b-col>
    </b-row>

  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '@/config/pluginInit'

import PaleCard from '@/components/custom/PaleCard'

import { SUserDashboard } from '@/services'

export default {

  name: 'UserDashboard',

  middleware: ['auth', 'user'],

  components: {
    PaleCard
  },

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      fetching: false,
      expenses: {
        pending: 0,
        processing: 0,
        disapproved: 0,
        released: 0,
        canceled: 0
      },
      approvals: {
        pending: 0,
        disapproved: 0,
        approved: 0
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  mounted () {
    core.index()
    this.getStatistics()
  },

  methods: {

    async getStatistics () {
      this.fetching = true
      return await SUserDashboard.get().then(
        ({ data }) => {
          this.expenses.pending = data.request_pending
          this.expenses.processing = data.request_processing
          this.expenses.disapproved = data.request_disapproved
          this.expenses.released = data.request_released
          this.expenses.canceled = data.request_canceled
          this.approvals.pending = data.approver_pending
          this.approvals.disapproved = data.approver_disapproved
          this.approvals.approved = data.approver_approved
          this.fetching = false
        }
      )
    }

  }
}
</script>
